import { render, staticRenderFns } from "./FoundingStory.vue?vue&type=template&id=5b83037f&scoped=true&"
import script from "./FoundingStory.vue?vue&type=script&lang=js&"
export * from "./FoundingStory.vue?vue&type=script&lang=js&"
import style0 from "./FoundingStory.vue?vue&type=style&index=0&id=5b83037f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83037f",
  null
  
)

export default component.exports